import React from 'react';
import { BaseFilterCheckboxSelect } from 'src/components/sidebar-filters/base/BaseFilterCheckboxSelect';

interface IBillUtilityFilterSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    options: { value: string; label: string }[];
    label?: string;
}

export const BillUtilityFilterSelect: React.FC<IBillUtilityFilterSelectProps> = ({ value, onChange, options, label = 'Utility' }) => {
    return (
        <BaseFilterCheckboxSelect
            label={label}
            multiple
            resizable
            searchable
            selectedCountInLabel
            showSelectAllOption={false}
            options={options}
            value={value}
            onChange={v => onChange(v as string[])}
        />
    );
};
